import React, { useEffect, useState, useRef } from "react";
import TapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import { useSelector } from "react-redux";
import { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import TapHelper from "../../../services/TapHelper";
import Chart from "react-google-charts";
import TapSelect from "../../../components/ui/TapSelect";
import DateService from "../../../services/DateService";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import CurrencyFormatter from "../../../services/CurrencyFormatter";


const QuotationWidget = (props) => {
    const updateMyDashboardRef = useRef();
    const access_token = useSelector(state => state.auth.access_token)
    const widgetUrl = INVENTORY_API_BASE_URL_2 + "/quotation_widget_data"
    const widget_keys = useSelector(state => state.app.user_info?.widget_keys || []);
    const allWarehouses = useSelector(state => state.app.warehouses ? state.app.warehouses : []);

    const [reload, setReload] = useState(false)
    const [widgetData, setWidgetData] = useState(null)

    const [quotationData, setQuotationData] = useState({
        loading: false,
        data: [],
        remark_time: '',
    })
    const [formData, setFormData] = useState({
        warehouses: [],
        userFilters: [
            { value: 'tagged_me', label: 'My Tagged Quotation' },
            { value: 'created_by_me', label: 'Quotation Created By Me' },
        ],
        filterData: {
            canChange: false,
            tagged_user_filter: "",
            search_warehouse_id: "",
        }
    })

    useEffect(() => {
        if (!formData.filterData.canChange) return;
        quotationWidgetData();
    }, [formData.filterData]);

    useEffect(() => {
        setFormData(pre => ({
            ...pre,
            warehouses: allWarehouses.map(w => ({ value: w.id, label: `${w.name} (${w.code})` }))
        }))
        const widget =
            widget_keys?.length > 0
                ? widget_keys.find(w => w.key === "quotation_status_wise_widget")
                : null;

        setWidgetData(widget);
    }, []);

    useEffect(() => {
        if (!reload) return;

        quotationWidgetData();
        setReload(false);

    }, [reload]);

    useEffect(() => {
        setQuotationData(prev => ({ ...prev, loading: true }));

        const cache = localStorage.getItem('quotationWidget');

        if (cache) {
            const parsed = JSON.parse(cache);

            const diff = DateService.differenceInSeconds(
                moment(parsed.time, 'DD-MM-YYYY HH:mm A').format()
            );

            if (diff <= 86400) {
                setQuotationData({
                    data: parsed.data,
                    loading: false,
                    remark_time: parsed.time,
                });
                return;
            } else {
                localStorage.removeItem('quotationWidget');
            }
        }

        // Only if no valid cache
        quotationWidgetData();

    }, []);
   
    const quotationWidgetData = () => {
        setQuotationData(prev => ({ ...prev, loading: true }));

        let params = {
            ...formData.filterData,
            reload: reload ? 'reload' : false
        };

        HttpAPICall.withAthorization('GET', widgetUrl, access_token, params, {}, (response) => {
            const res = response.data;

            setQuotationData({
                data: res.data,
                remark_time: res.time,
                loading: false
            });

            // ✅ ADD THIS
            localStorage.setItem('quotationWidget', JSON.stringify(res));

        }).catch(() => {
            setQuotationData(prev => ({ ...prev, loading: false }));
        });
    }
    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, {
            key: "quotation_status_wise_widget",
            name: "Quotation Status wise Widget"
        });
    };
    const handleCountClick = (data) => {
        const statusId = data.id;
        const taggedUserFilter = formData.filterData.tagged_user_filter;
        const warehouseId = formData.filterData.search_warehouse_id;

        const params = new URLSearchParams();
        if (statusId) {
            params.append('status_id', statusId);
        }
        if (taggedUserFilter) {
            params.append('tagged_user_filter', taggedUserFilter);
        }
        if (warehouseId) {
            params.append('warehouse_id', warehouseId);
        }

        const url = `/quotation_list?${params.toString()}`;
        window.open(url, '_blank');
    };

    const totalValue = quotationData.data.reduce((acc, d) =>
        acc + (parseInt(d.total_quotations) > 0 ? parseInt(d.total_quotations) : 0), 0);
    return (
        <div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-5">
                        <h6 className="fw-bold primary_color mb-0">Quotation Widget</h6>
                    </div>
                    <div className="col-3">
                        <TapSelect
                            options={formData.userFilters}
                            changeEvent={(selectedOption) => {
                                setFormData(prev => ({
                                    ...prev,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        tagged_user_filter: selectedOption ? selectedOption.value : ""
                                    }
                                }));
                            }}
                            value={formData.userFilters.find(u => u.value === formData.filterData.tagged_user_filter)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="100%"
                            placeholder="All Quotation" 
                        />
                    </div>
                    <div className="col-3 p0">
                        <TapSelect
                            options={formData.warehouses}
                            changeEvent={(selectedOption) => {
                                setFormData(pre => ({
                                    ...pre,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        search_warehouse_id: selectedOption ? selectedOption.value : ""
                                    }
                                }))
                            }}
                            value={formData.warehouses.find(u => u.value == formData.filterData.search_warehouse_id)}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            placeholder="All Warehouses"
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <div className="dropdown">
                            <TapIcon.imageIcon
                                icon={TapIcon.ListActionIcon}
                                alt="action-icon"
                                className="img-fluid px-2 btn btn-light btn-block"
                                data-bs-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-expanded="false"
                            />
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>
                                    Refresh
                                </li>
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>
                                    {!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center mt-2">
                    <div className="col-6">
                        <table className="table table-hover table-bordered  bg-white">
                            <thead className="table-secondary">
                                <tr>
                                    <th style={{ width: "33%" }} className="text-start" >Status</th>
                                    <th style={{ width: "33%" }} className="text-center ">No. of Transactions</th>
                                    <th style={{ width: "33%" }} className="text-end "> Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {quotationData.loading
                                    ?
                                    <tr>
                                        <td className="text-center" colSpan="3"><Loader /></td>
                                    </tr>
                                    :
                                    quotationData.data && quotationData.data?.length > 0 ?
                                        quotationData.data.map((d, i) => (
                                            <tr key={i}>
                                                <td>{d.name}</td>
                                                <td className="text-center">
                                                    {d.total_quotations ?
                                                        <>
                                                            <span
                                                                className="text-primary "
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleCountClick(d)}
                                                            >
                                                                {d.total_quotations}
                                                            </span>
                                                        </>
                                                        : "-"}
                                                </td>
                                                <td className="text-end">
                                                    <CurrencyFormatter currencyCode={props.default_currency} amount={parseInt(d?.total_amount_vc)}/>
                                                </td>
                                            </tr>
                                        ))
                                        : <tr><td className="text-center" colSpan="3">No Records Found</td></tr>

                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="col-6 p0 mt-3 mb-1">
                        {quotationData.loading
                            ? <Loader />
                            :
                            (quotationData.data && totalValue > 0 ? (
                                <Chart
                                    chartType="PieChart"
                                    data={[['Status Name', 'Quotation Count']].concat(quotationData.data.map((d) => { return [d.name, d.total_quotations]; }))}
                                    options={{
                                        legend: { position: 'labeled', labeledValueText: 'both' },
                                        pieSliceText: 'none',
                                        chartArea: { width: '90%', height: '90%' },
                                    }}
                                    rootProps={{ 'data-testid': '1' }} />
                            ) : null)}

                    </div>
                </div>
                <div className="col-sm-12 text-muted fs11">
                    Report as of {quotationData.remark_time}
                </div>
            </div>
            <UpdateMyDashboardForm ref={updateMyDashboardRef} />

        </div>
    );
};

export default QuotationWidget;